import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';
import { LETTER_SPACING, typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

export const Container = styled.div`
  padding: 100px 0 ${OFFSET.L};
  margin: 0 auto;
  max-width: 1440px;

  ${media.mobile} {
    padding: 150px 0 ${OFFSET.XL};
  }
`;

export const AllArtists = styled.div`
  padding: ${OFFSET.L} ${OFFSET.M};
  text-align: center;

  ${media.mobile} {
    padding: ${OFFSET.XL} ${OFFSET.M};
  }
`;

export const ArtistsCopy = styled.span`
  padding: 8px 0;
  margin-right: 14px;
  text-transform: uppercase;
`;

export const CurrentArtists = styled.div`
  padding: 0 ${OFFSET.M} ${OFFSET.L};
  margin: 0 auto;
  text-align: center;
`;

export const MotionContainer = styled(motion.div)`
  position: ${({ position }: { position: string }) => position};
  top: 0;
  left: 0;
  width: 100%;
  transform-origin: center top;
  will-change: transform, opacity;
`;

const previewFadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const PreviewPanel = styled.div`
  display: none;
  grid-template-rows: 1fr 1fr;
  position: fixed;
  top: 0;
  right: 0;
  width: 324px;
  height: 100vh;
  margin-top: 8vh;
  padding: ${OFFSET.M};
  background: ${COLORS.WHITE};
  z-index: 1;
  animation: ${previewFadeIn} 0.5s;

  ${media.mobile} {
    display: grid;
  }
`;

export const PreviewImage = styled.img`
  width: 100%;
  margin-top: auto;
  margin-bottom: ${OFFSET.M};
`;

export const PreviewBio = styled.div`
  p {
    ${typography({ spacing: LETTER_SPACING.S })};
    margin: 0;
    max-width: 252px;
    overflow: hidden;
  }
`;

export const AnimateContainer = styled.div`
  position: relative;
  min-height: 310px;
`;
